import routes from './routes';
import Route from 'route-parser';
import { Box, Alert, AlertTitle } from '@mui/material';
import useRoute from '../data/hooks/useRoute';
import SusSidebar from '../components/Sus/SusSidebar';

const GenerateComponent = (route: string) => {
  // Remove leading slash if present

  const routeWithoutLeadingSlash = route.startsWith('/') ? route.substring(1) : route;

  const cleanRoute = routeWithoutLeadingSlash.split('?')[0];

  if (cleanRoute.length === 0) return null;

  const matchedRoute = routes.find((sb) => {
    const routeParser = new Route(sb.path);

    return routeParser.match(cleanRoute);
  });

  if (matchedRoute) {
    const cacheSeed = String(Math.random());
    const props = new Route(matchedRoute.path).match(cleanRoute);
    const propsAndCache = { ...props, __cacheSeed: cacheSeed };
    const Component = matchedRoute.component;

    return <SusSidebar text='Fetching'><Component {...propsAndCache} /></SusSidebar>;
  }
  return (
    <Box p={2}>
      <Alert severity='error'>
        <AlertTitle>Route Error</AlertTitle>
        Route &rsquo;<code>{cleanRoute}</code>&rsquo; not found
      </Alert>
    </Box>
  );
};

const SideBar = () => {

  const sidebarPath = useRoute().sidebarPath;

  return GenerateComponent(sidebarPath);
};

export default SideBar;